import React, {Component} from 'react';
import './inbargraph.css';
import * as d3 from 'd3';
import _ from 'lodash';
import {graphOffsetKey} from '../../../../constants/constants';

let colors = [
    '#3498db',
    '#9b59b6',
    '#82ff59',
    '#d01c3a',
    '#f1c40f',
];

function updateGraph(graph) {
    return (svg, data) => {
        let margin = graph.margin;

        let width = graph.width - margin.left - margin.right;
        let height = graph.height - margin.top - margin.bottom;
        svg = d3.select(svg);
        let g = svg.select('g.con');
        g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        
        let xScale = d3.scaleBand().range([0, width]).domain(Object.keys(data)).paddingInner(.8).paddingOuter(.3);
        let yScale = d3.scaleLinear().range([height, 0]).domain([0, d3.max(_.values(data)) * 1.3]);

        let xAxis = d3.axisBottom(xScale);
        g.select('g.x.axis').attr('transform', 'translate(0, ' + height + ')').call(xAxis);
        let yAxis = d3.axisLeft(yScale).ticks(5);
        g.select('g.y.axis').call(yAxis);

        let bars = g.select('g.bars').selectAll('rect.bar')
            .data(_.toPairs(data));
        bars.enter().append('rect')
            .attr('class', 'bar')
            .attr('fill', (d, i) => colors[i % colors.length])
            .attr('width', xScale.bandwidth())
            .merge(bars)
            .attr('x', d => xScale(d[0]))
            .attr('y', d => yScale(d[1]))
            .attr('height', d => height - yScale(d[1]));
        bars.exit().remove();

        g.select('g.graphName').select('text')
            .text(graph.props.data.graphSetName);
    }
}

export default class InBarGraph extends Component {
    margin = {
        top: 20, right: 40, bottom: 20, left: 40
    }
    constructor() {
        super();
        this.uid = 'InBarGraph-' + parseInt(Math.random() * 100000000, 10);
    }
    componentDidMount() {
        window.addEventListener('resize', () => {
            clearTimeout(this.resizeDebounce);
            this.resizeDebounce = setTimeout(() => {
                let rect = this.refs.svg.getBoundingClientRect();
                this.width = rect.width;
                this.height = rect.height;
                this.draw(this.data);
            }, 500);
        })
        window.addInGraph2Listener('zoom', this.uid, this.onZoom, this.props.data.graphSetName);
    }
    onZoom = (event) => {
        let data = [];
        if(this.data.data) data = this.data.data[0].filter(f => f.time >= event.xDomainValue[0] && f.time <= event.xDomainValue[1]);
        let bdata = this.props.data.processBarData(data);
        updateGraph(this)(this.refs.svg, bdata);
    }
    setNoData = () => {
    }
    setBusy = () => {
    }
    draw = (data, drawConfig) => {
        console.log("inbar graph")
        if(data && data.data){
            this.data = data;
            let rect = this.refs.svg.getBoundingClientRect();
            this.width = rect.width;
            this.height = rect.height;
            let bdata = this.props.data.processBarData(data.data[0]);
            updateGraph(this)(this.refs.svg, bdata);
        }
    }
    mouseDown = () => {
    }
    mouseUp = () => {
    }
    render() {
        return <div className={"InBarGraph " + (this.props.data.graphSetName || '')}>
            <svg ref="svg" width={this.props.config.width} height={this.props.config.height} onMouseDown={this.mouseDown} onMouseUp={this.mouseUp}>
                <g className="con">
                    <g className="x axis"></g>
                    <g className="y axis"></g>
                    <g className="bars"></g>
                    <g className="graphName">
                        <text x="10" y="10"></text>
                    </g>
                </g>
            </svg>
        </div>
    }
}